import { events } from "@planzone/events";
import { updateNotification } from "./utils/updateNotification";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceMoveListElementNotificationState = createStateReducer(
  initialState,
  {
    [events.moveListElementFailed]: (state, { error }) => ({
      ...state,
      queue: updateNotification(
        {
          key: "moveListElement",
          flags: pushIf({
            ...error,
            failure: !Object.values(error).includes(true),
          }),
          args: { failure: "true" },
        },
        state.queue,
      ),
    }),
  },
);

export { reduceMoveListElementNotificationState };
